module.exports = __webpack_public_path__ + "img/76002.d9f37203.svg";